import React, { useContext, useEffect, useState } from "react";
import { InvokePostServiceCall, server_path } from "../../api/apiServices";
import { useParams } from "react-router-dom";
import Header from "../../components/header/Header";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import ChatHistory from "../../components/chat-history/ChatHistory";
import { marked } from "marked";
import MainContainer from "../../components/main-container/MainContainer";
import {
  Autocomplete,
  Backdrop,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Markup } from "interweave";
import styled from "styled-components";
import { AppContext } from "../../AppContext";
import { getPageCount } from "../../utils/utils";
import { API } from "../../constants/APIConstant";

export const OldConvoContainer = styled.div`
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  flex: 1 1;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ada89a;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
  }

  // ::-webkit-scrollbar {
  //   width: 12px;
  // }

  // ::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222);
  //   border-radius: 10px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72);
  // }

  // scrollbar-width: thin;
  // scrollbar-color: #ada89a transparent;
`;

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;
function SimilarityDetails() {
  const { id } = useParams();
  const { userName } = useContext(AppContext);
  const [showSpinner, setShowSpinner] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [result, setResult] = useState([]);
  const notify = () => toast.error("Something Went Wrong!");

  const uploadFile = async () => {
    setShowSpinner(true);
    const backendUrl = `${server_path}${API.similarDocuments_generate_presigned_url_upload}`;
    let uploadFailed = false;
    try {
      const file = selectedFile[0];
      if (file) {
        // Create a URL for the uploaded file
        const url = URL.createObjectURL(file);
        let count = await getPageCount(url);
        if (count > 150) {
          const notify = () =>
            toast.error(
              `${file.name} has more than 150 pages. Please upload a PDF with fewer than 150 pages.`
            );
          notify();
          setShowSpinner(false);
          return;
        }
      }
      for (const file of selectedFile) {
        let requestBody = {
          fileName: file.name,
          projectName: id,
          userName: userName,
        };
        const options1 = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          redirect: "follow",
        };

        const response = await fetch(backendUrl, options1);
        const data = await response.json();
        const signedUrl = data.url;

        const options = {
          method: "PUT",
          headers: {
            "Content-Type": "application/pdf",
            // "Content-Disposition": `attachment; filename="${file.name}"`,
          },
          body: file,
        };

        const uploadResponse = await fetch(signedUrl, options);

        if (!uploadResponse.ok) {
          uploadFailed = true; // Mark upload as failed
          break; // Exit loop if any upload fails
        }
      }

      if (!uploadFailed && selectedFile.length > 0) {
        // const notifyAll = () => toast.success("All files uploaded");
        // notifyAll();

        let requestBody = {
          project_name: id,
        };

        let publicDocRes = await InvokePostServiceCall(
          API.similarDocuments_public_doc,
          requestBody
        );
        console.log(publicDocRes, "publicDoc Res");
        getResult();
      }
    } catch (error) {
      console.log(error, "error message");
      setShowSpinner(false);
      const notify = () => toast.error("Upload Failed");
      notify();
    }
  };

  const getResult = async () => {
    try {
      let response = await InvokePostServiceCall(
        API.similarDocuments_get_score,
        {
          folder_name: id,
          pdf_name: selectedFile[0].name,
        }
      );
      let result = await response.json();

      setResult(result);
      setShowSpinner(false);
    } catch (error) {
      console.log(error);
      setShowSpinner(false);
      notify();
    }
  };

  return (
    <MainContainer showHomeButton={true}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "10px 10px 0px 10px",
        }}
      >
        <ToastContainer />

        <input
          type="file"
          style={{
            border: "2px solid #1976d2",
            borderRadius: "5px",
            padding: "3px",
            marginRight: "10px",
          }}
          onChange={(e) => {
            setSelectedFile(e.target.files);
          }}
        />

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#004987",
            "&:hover": { backgroundColor: "#004987" },
          }}
          onClick={() => {
            setResult([]);
            uploadFile();
          }}
          disabled={!selectedFile}
        >
          Get Result{" "}
        </Button>
      </div>
      <OldConvoContainer className="old-convo-container">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showSpinner}
          // onClick={handleClose}
        >
          {/* <CircularProgress color="inherit" /> */}
          <Spinner />
        </Backdrop>

        {result.length > 0 && (
          <ConvoDiv
            // key={index}
            className={`old-chat ${"h-auto"}`}
            style={{ display: "flex" }}
          >
            <h4>Result:</h4>

            <TableContainer sx={{ display: "flex", justifyContent: "center" }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>PDF Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Similarity Index</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Similarity</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {result.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <a href={row.pdf_link}>{row.pdf_name}</a>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.score}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.score >= 0.75 && row.score <= 0.9
                          ? "High"
                          : row.score >= 0.5 && row.score <= 0.75
                          ? "Medium"
                          : row.score < 0.5
                          ? "Low"
                          : "Very High"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </ConvoDiv>
        )}
      </OldConvoContainer>
    </MainContainer>
  );
}

export default SimilarityDetails;
